// removed by extract-text-webpack-plugin
module.exports = {"NavItems":"NavItems__NavItems__3fZSa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/NavItems/NavItems.css
// module id = 82
// module chunks = 3